module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a7-4-bf7dd1de878367af2e6db71885e993cc.jpg";